import React from "react"
import { Link } from "gatsby"

import { withImageText } from "./withImageText"
import { StyledContainer } from "../../Styled/Container"
import { StyledRow } from "../../Styled/Row"
import {
  Section,
  Background,
  Column,
  Images,
  Image,
  Icon,
  IconInner,
  Svg,
  Pretitle,
  Title,
  Subtitle,
  Buttons,
  Button,
  Content,
} from "./ImageTextStyles"

export const ImageText = withImageText(
  ({ content, handlePopup, handleRegister, image, link, locales, report, pretitle, title, showRegister, showLink }): JSX.Element => (
    <Section>
      <Background items={`stretch`} withWrap>
        <Column width={`md:1/2`} />
        <Column blue width={`md:1/2`} />
      </Background>

      <StyledContainer width={`xl`}>
        <StyledRow items={`stretch`} gutter={`md`} withWrap>
          <Column justify={`center`} items={`center`} gutter={`md`} width={`md:1/2`}>
            <Content>
              {pretitle && <Pretitle align={`left`}>{pretitle}</Pretitle>}
              {title && (
                <Title as={`div`} align={`left`} colour={`navy`}>
                  {title}
                </Title>
              )}
              {content && (
                <Subtitle align={`left`} colour={`navy`}>
                  {content}
                </Subtitle>
              )}
            </Content>
          </Column>
          <Column justify={`center`} items={`center`} gutter={`md`} width={`md:1/2`}>
            <Icon>
              <IconInner>
                <Svg viewBox="0 0 530 461" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M167.159 383.883l82.902 71.496c8.715 7.516 21.628 7.492 30.315-.055l189.039-164.232C506.342 261.083 530 215.231 530 163.871 530 73.367 456.623 0 366.107 0c-38.144 0-73.267 13.05-101.108 34.893C237.158 13.05 202.035.002 163.893.002 73.377.002 0 73.369 0 163.872c0 90.504 73.377 163.871 163.893 163.871 45.826 0 87.293-18.835 117.009-49.127l101.1-98.42c9.016-8.778 9.209-23.201.43-32.216-8.778-9.015-23.204-9.208-32.22-.431l-101.497 98.808-.197.202c-21.51 22.004-51.457 35.62-84.625 35.62-65.348 0-118.323-52.968-118.323-118.307 0-65.338 52.975-118.306 118.323-118.306 25.012 0 48.192 7.743 67.304 20.987l-83.199 80.995c-9.016 8.777-9.209 23.2-.43 32.215 8.778 9.015 23.204 9.208 32.22.431l101.497-98.808.197-.202c21.51-22.004 51.457-35.62 84.625-35.62 65.348 0 118.323 52.968 118.323 118.307 0 37.171-17.119 70.328-43.992 92.054l-.314.253-174.991 152.028-68.21-58.826c-9.53-8.218-23.917-7.156-32.136 2.372-8.219 9.528-7.157 23.913 2.372 32.131z"
                    fill="url(#heartGradient)"
                  />
                  <defs>
                    <radialGradient id="heartGradient" cx="0" cy="0" r="3">
                      <stop stopColor="#FC354C" />
                      <stop offset=".13" stopColor="#FC354C" />
                      <stop offset=".318" stopColor="#0ABFBC" />
                      <stop offset=".998" stopColor="#0ABFBC" />
                    </radialGradient>
                  </defs>
                </Svg>
              </IconInner>
            </Icon>
            <Images>
              {image?.desktop && <Image alt={image?.desktop?.alt} fluid={image?.desktop} screen={`lg>`} />}
              {image?.mobile && <Image alt={image?.mobile?.alt} fluid={image?.mobile} screen={`<md`} />}
            </Images>
            <Buttons>
              {report ? (
                <Button onClick={handlePopup} title={locales?.additionalReportActionButton}>
                  {locales?.additionalReportActionButton}
                </Button>
              ) : showRegister ? (
                <Button onClick={handleRegister} title={locales?.additionalRegister}>
                  {locales?.additionalRegister}
                </Button>
              ) : (
                showLink && (
                  <Button as={Link} to={link?.url} title={link?.title}>
                    {link?.title}
                  </Button>
                )
              )}
            </Buttons>
          </Column>
        </StyledRow>
      </StyledContainer>
    </Section>
  )
)

export default ImageText
